import { CommonModule as ACommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { DevModule } from '@tytapp/app/dev';
import { ArticlesModule } from '@tytapp/articles';
import { ChatModule } from '@tytapp/chat';
import { TYTCommonModule } from '@tytapp/common';
import { CommonUiModule } from '@tytapp/common-ui';
import { LiveStreamsModule } from '@tytapp/live-streams';
import { MediaPlaybackModule } from '@tytapp/media-playback';
import { LiveJumpComponent } from './live-jump/live-jump.component';
import { LiveSchedulePageComponent } from './live-schedule-page.component';
import { WatchLiveComponent } from './watch-live/watch-live.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LiveUiModule } from '@tytapp/live-ui';

@NgModule({
    imports: [
        FormsModule,
        ACommonModule,
        TYTCommonModule,
        MediaPlaybackModule,
        CommonUiModule,
        LiveStreamsModule,
        ArticlesModule,
        ChatModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatTabsModule,
        MatTooltipModule,
        MatDividerModule,
        DevModule,
        LiveUiModule,
        RouterModule.forChild([
            { path: '', component: LiveJumpComponent, pathMatch: 'full' },
            { path: 'members', component: LiveJumpComponent, data: { prefer: 'members-only' } },
            { path: 'members/qc', component: LiveJumpComponent, data: { prefer: 'members', qc: true } },
            { path: 'public', component: LiveJumpComponent, data: { prefer: 'public' } },
            { path: 'public/qc', component: LiveJumpComponent, data: { prefer: 'public', qc: true } },
            { path: 'streams/:streamID', component: WatchLiveComponent, data: { mode: 'qc-public' } },
            { path: 'schedule/v1', component: LiveSchedulePageComponent },
        ]),
        MatButtonToggleModule
    ],
    declarations: [
        LiveSchedulePageComponent,
        LiveJumpComponent,
        WatchLiveComponent
    ],
    exports: [
        LiveSchedulePageComponent,
        LiveJumpComponent,
        WatchLiveComponent
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class LivePagesModule {
    static forRoot(): ModuleWithProviders<LivePagesModule> {
        return {
            ngModule: LivePagesModule,
            providers: []
        };
    }
}
